import { Combobox as HeadlessCombobox } from '@headlessui/react';

type ComboboxBaseProperties<T> = {
  readonly children: {
    title?: JSX.Element;
    leadingIcon?: JSX.Element;
    input?: JSX.Element;
    dropDownButton?: JSX.Element;
    options?: JSX.Element;
    error?: JSX.Element;
  };
  readonly value: T;
  readonly className?: string;
  readonly name?: string;
  readonly disabled?: boolean;
  readonly onBlur?: () => void;
  readonly onChange?: (value: T) => void;
  readonly multiple?: boolean;
};

export function ComboboxBase<T>({
  value,
  children,
  className,
  disabled,
  name,
  onBlur,
  onChange,
  multiple,
}: ComboboxBaseProperties<T>) {
  return (
    <HeadlessCombobox
      as="div"
      value={value}
      onChange={onChange}
      className={className}
      disabled={!!disabled}
      name={name}
      multiple={multiple}
      onBlur={onBlur}
    >
      {children.title}
      <div className="relative w-full">
        {children.leadingIcon}
        {children.input}
        {children.dropDownButton}
        {children.options}
      </div>
      {children.error}
    </HeadlessCombobox>
  );
}
